import styled, { keyframes } from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
  max-width: 200px;
  border-left: ${({ theme, noBorder }) =>
    noBorder ? `none` : `solid 1px ${theme.dark}`};
  padding: 0 5px 0 20px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    margin-right: 0;
    border-right: 0;
    border-left: ${({ theme, noBorder }) =>
      noBorder ? `none` : `solid 1px ${theme.dark}`};
    margin-bottom: 5%;
    max-width: 100%;
  }
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme }) => theme.white};
  width: 100%;
  transition: opacity 0.3s;
`;

export const InputWrapper = styled.div`
  width: 100%;
  height: 25px;

  .react-datepicker-wrapper {
    width: 100%;
    height: 25px;

    div {
      .react-datepicker__close-icon {
        margin-right: 15px;
      }

      .react-datepicker__close-icon::after {
        background-color: ${({ theme }) => theme.black};
        display: flex;
        width: 12px;
        height: 12px;
        position: absolute;
        top: 11px;
        left: -13px;
        justify-content: center;
        align-items: center;
      }
    }
    button {
      font-family: ${({ theme }) => theme.primaryFont};
      color: white;
    }
  }

  .react-datepicker__current-month {
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.h5}px;
    color: ${({ theme }) => theme.dark};
  }

  .react-datepicker__year-option {
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.paragraph}px;
    color: ${({ theme }) => theme.dark};
  }

  .react-datepicker__year-read-view--selected-year {
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.paragraph}px;
    color: ${({ theme }) => theme.dark};
  }

  .react-datepicker__day-name {
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.paragraph}px;
    color: ${({ theme }) => theme.dark};
  }

  .react-datepicker__day {
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.paragraph}px;
    color: ${({ theme }) => theme.dark};
  }

  .react-datepicker__day--today {
    background-color: transparent;
    color: #000;
    font-weight: 400;
  }

  react-datepicker__day--today:hover {
    background-color: transparent;
    color: #000;
    font-weight: 400;
  }

  .react-datepicker__day--keyboard-selected:hover {
    background-color: transparent;
  }

  .react-datepicker__day--disabled {
    opacity: 0.2;
  }
`;

const loadingSvg = keyframes`
  0%{
    opacity: 0;
  }
  50%{
    opacity: 1;
  }
  75%{
    opacity: 0;
  }
  100%{
    opacity: 0;
  }
`;

export const Picker = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  border-style: none;
  width: 100%;
  height: 25px;
  line-height: 37px;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme, dateSelected }) =>
    dateSelected ? theme.dark : '#808080'};

  div {
    display: flex;
    flex-direction: row-reverse;

    svg:nth-child(2) {
      margin-right: 10px;
      path {
        opacity: 0;
      }

      path:first-child {
        animation: ${loadingSvg} 0.9s infinite;
        animation-delay: 0.6s;
      }

      path:nth-child(2) {
        animation: ${loadingSvg} 0.9s infinite;
        animation-delay: 0.3s;
      }

      path:nth-child(3) {
        animation: ${loadingSvg} 0.9s infinite;
      }
    }
  }
`;
